import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, Transition as _Transition, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4012df81"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "boostDetails__header" }
const _hoisted_2 = { class: "boostDetails__header__tile" }
const _hoisted_3 = { class: "boostDetails__header__tile" }
const _hoisted_4 = { class: "boostDetails__header__tile" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "commision"
}
const _hoisted_7 = {
  key: 1,
  class: "commision"
}
const _hoisted_8 = {
  key: 2,
  class: "commision"
}
const _hoisted_9 = {
  key: 3,
  class: "commision"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { style: {"display":"flex","justify-content":"center","margin":"10px auto"} }
const _hoisted_12 = { class: "validationPopup__body" }
const _hoisted_13 = { class: "validationPopup__description" }
const _hoisted_14 = { class: "field" }
const _hoisted_15 = { class: "validationPopup__btn" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "C4E", -1 /* HOISTED */))
const _hoisted_17 = { class: "invalid-feedback" }
const _hoisted_18 = {
  key: 0,
  class: "validationPopup__reservationReq"
}
const _hoisted_19 = {
  key: 0,
  class: "validationPopup__btnHolder"
}
const _hoisted_20 = { class: "validationPopup__btns" }
const _hoisted_21 = { style: {"flex":"1 1"} }
const _hoisted_22 = {
  key: 1,
  class: "validationPopup__btns"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode($setup["Dialog"], {
      visible: $props.visible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ($setup.emit('close'))),
      modal: "",
      style: { width: '800px', 'z-index': '100' },
      header: $props.boost.poolDescription
    }, {
      default: _withCtx(() => [
        ($setup.loginPopupStatus)
          ? (_openBlock(), _createBlock($setup["LoginPopUp"], {
              key: 0,
              showAddressOption: false,
              onClose: _cache[0] || (_cache[0] = ($event: any) => ($setup.loginPopupStatus =! $setup.loginPopupStatus))
            }))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('BOOST.COMMON.LOCKUP_PERIOD')) + ":", 1 /* TEXT */),
            _createElementVNode("h4", null, _toDisplayString($setup.msToDays($props.boost.lockupPeriod)) + " " + _toDisplayString(_ctx.$t('BOOST.COMMON.DAYS')), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('BOOST.COMMON.APR')) + ":", 1 /* TEXT */),
            _createElementVNode("h4", null, _toDisplayString(($setup.calculateApr($props.boost)).toFixed(2)) + "%", 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('BOOST.COMMON.POOL_USAGE')) + ":", 1 /* TEXT */),
            _createVNode($setup["CoinAmount"], {
              amount: $setup.poolUsage,
              "show-tooltip": true,
              "tooltip-only": "",
              style: {"width":"90%","margin-bottom":"10px"}
            }, {
              default: _withCtx(() => [
                ($setup.percentagePoolUsage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      ($setup.percentagePoolUsage.isBiggerThanOrEqualTo(0.90))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("div", {
                              class: "level-1",
                              style: _normalizeStyle('flex-basis:' + ($setup.percentagePoolUsage).multiply(100).toFixed(2) + '%')
                            }, null, 4 /* STYLE */),
                            _createVNode($setup["PercentsView"], {
                              class: "level-border",
                              amount: $setup.percentagePoolUsage,
                              precision: 2
                            }, null, 8 /* PROPS */, ["amount"])
                          ]))
                        : _createCommentVNode("v-if", true),
                      ($setup.percentagePoolUsage.isBiggerThanOrEqualTo(0.80) && !$setup.percentagePoolUsage.isBiggerThanOrEqualTo(0.90))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("div", {
                              class: "level-2",
                              style: _normalizeStyle('flex-basis:' + ($setup.percentagePoolUsage).multiply(100).toFixed(2) + '%')
                            }, null, 4 /* STYLE */),
                            _createVNode($setup["PercentsView"], {
                              class: "level-border",
                              amount: $setup.percentagePoolUsage,
                              precision: 2
                            }, null, 8 /* PROPS */, ["amount"])
                          ]))
                        : _createCommentVNode("v-if", true),
                      ($setup.percentagePoolUsage.isBiggerThanOrEqualTo(0.70) && !$setup.percentagePoolUsage.isBiggerThanOrEqualTo(0.80))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("div", {
                              class: "level-3",
                              style: _normalizeStyle('flex-basis:' + ($setup.percentagePoolUsage).multiply(100).toFixed(2) + '%')
                            }, null, 4 /* STYLE */),
                            _createVNode($setup["PercentsView"], {
                              class: "level-border",
                              amount: $setup.percentagePoolUsage,
                              precision: 2
                            }, null, 8 /* PROPS */, ["amount"])
                          ]))
                        : _createCommentVNode("v-if", true),
                      (!$setup.percentagePoolUsage.isBiggerThanOrEqualTo(0.70))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("div", {
                              class: "level-4",
                              style: _normalizeStyle('flex-basis:' + ($setup.percentagePoolUsage).multiply(100).toFixed(2) + '%')
                            }, null, 4 /* STYLE */),
                            _createVNode($setup["PercentsView"], {
                              class: "level-border",
                              amount: $setup.percentagePoolUsage,
                              precision: 2
                            }, null, 8 /* PROPS */, ["amount"])
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_10, "updating"))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["amount"])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode($setup["InfoMessage"], {
            header: "BOOST.POPUP.INFO_HEADER",
            "header-variables": {timeToComplete: $setup.msToDays($props.boost.lockupPeriod)},
            texts: ['BOOST.POPUP.INFO_TEXT_1',
                        'BOOST.POPUP.INFO_TEXT_2',
                        'BOOST.POPUP.INFO_TEXT_3']
          }, null, 8 /* PROPS */, ["header-variables", "texts"]),
          _createCommentVNode("        'BOOST.POPUP.INFO_TEXT'+")
        ]),
        _createCommentVNode("      <div style=\"display: flex; justify-content: center; margin: 10px auto\">"),
        _createCommentVNode("        <div style=\"display: flex; justify-content: center; flex-direction: column;\">"),
        _createCommentVNode("          <span>1.\tOpting for a longer staking period will earn a better APR.</span>"),
        _createCommentVNode("          <span>2.\tAll rewards are paid in C4E in weekly cycles and automatically sent to wallets.</span>"),
        _createCommentVNode("          <span>3.\tUsers are not allowed to unstake their staked tokens until the redemption period is over.</span>"),
        _createCommentVNode("        </div>"),
        _createCommentVNode("      </div>"),
        _createVNode($setup["Form"], {
          onSubmit: $setup.action,
          "validation-schema": $setup.baseSchema,
          class: "validationPopup__body",
          as: "form"
        }, {
          default: _withCtx(({ errors }) => [
            _createElementVNode("div", _hoisted_12, [
              _createVNode($setup["AmountView"], {
                class: "validationPopup__amount",
                coins: $setup.amountToPass,
                "show-denom": true,
                precision: 4,
                "orig-denom": $setup.useConfigurationStore().config.getConvertedDenom(),
                "reduce-big-number": false
              }, {
                "logo-front": _withCtx(() => [
                  _createVNode($setup["C4EIcon"], {
                    icon: "c4e-circle",
                    size: "30"
                  })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["coins", "orig-denom"]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode($setup["Field"], {
                    modelValue: $setup.amount,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.amount) = $event)),
                    name: "amount",
                    placeholder: " ",
                    type: "number",
                    class: _normalizeClass(["form-control", { 'is-invalid': errors.amount }]),
                    style: {"width":"100%"},
                    disabled: !$setup.canModify
                  }, null, 8 /* PROPS */, ["modelValue", "class", "disabled"]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('COMMON.INPUT.AMOUNT')), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.amount = $setup.getMax()))
                    }, "Max"),
                    _hoisted_16
                  ]),
                  _createCommentVNode("              <p style=\"text-align: left\">"),
                  _createCommentVNode("                commission ~ {{commissionForOperation.toFixed(2)}} c4e"),
                  _createCommentVNode("              </p>"),
                  _createElementVNode("div", _hoisted_17, _toDisplayString(errors.amount ? errors.amount : ""), 1 /* TEXT */),
                  _createVNode(_Transition, { name: "slide-fade" }, {
                    default: _withCtx(() => [
                      ($setup.showReserveCheckbox)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.reserveCoins) = $event))
                            }, null, 512 /* NEED_PATCH */), [
                              [_vModelCheckbox, $setup.reserveCoins]
                            ]),
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t('BOOST.COMMON.RESERVE', {amount: $setup.fee+$setup.reservedCoins})), 1 /* TEXT */)
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ])
            ]),
            ($setup.canModify)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("span", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('BOOST.POPUP.AMOUNT')) + ": ", 1 /* TEXT */),
                        _createCommentVNode("                <span style=\"font-weight: bold;\">{{calculateReward(boost,amount).toFixed(4)}} C4EE</span>"),
                        _createVNode($setup["CoinAmount"], {
                          amount: $setup.calculateReward($props.boost,$setup.amount * $setup.useConfigurationStore().config.getViewDenomConversionFactor()),
                          "show-denom": true,
                          "show-tooltip": true,
                          "reduce-big-number": true,
                          precision: 2
                        }, null, 8 /* PROPS */, ["amount"])
                      ])
                    ]),
                    _createVNode(_component_Button, {
                      class: "validationPopup__button",
                      type: "submit"
                    }, {
                      default: _withCtx(() => [
                        _createVNode($setup["StakeManagementIcon"], { icon: "delegate" }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('BOOST.POPUP.LOCK_C4E')), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createTextVNode(_toDisplayString(_ctx.$t('ERRORS.CONNECT_WALLET')) + " ", 1 /* TEXT */),
                  (!$setup.useUserStore().isLoggedIn)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        class: "secondary",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.loginPopupStatus =! $setup.loginPopupStatus))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('COMMON.CONNECT')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true)
                ]))
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["validation-schema"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["visible", "header"])
  ]))
}